<span class="vin-left">{{ leftVin }}</span><span class="vin-right">{{ rightVin }}</span>
